import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const logosSliders = document.querySelectorAll('[data-slider-logos]');

const homeSlider = new Swiper('#homeSlider', {
    modules: [Navigation, Pagination, EffectFade, Autoplay],
    autoplay: {
        delay: 4000
    },
    effect: 'fade',
    speed: 1000,
    pagination: {
        el: '#homeSliderPagination',
        clickable: true
    },
    navigation: {
        prevEl: '#homeSliderPrev',
        nextEl: '#homeSliderNext'
    }
});


[...logosSliders].forEach((slider) => {
    const logosSlider = new Swiper(slider, {
        modules: [Navigation, Pagination, EffectFade, Autoplay],
        autoplay: {
            delay: 4000
        },
        speed: 1000,
        slidesPerView: 2,
        breakpoints: {
            576: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 6
            }
        }
    });
});